import { lazy } from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from 'packages/utils';

import HolidayWrapper from './components/HolidayWrapper';
import { PATHS } from './constants';

const HolidaysList = lazy(() => import('./screens/HolidaysList'));

const holidaysRoutes = [
  {
    component: props => <HolidayWrapper component={HolidaysList} routeProps={props} />,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.HOLIDAYS?.LIST || ALLOWED_ROLES.ORGANIZATIONS.GET,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.TIME_TRACKER, holidaysRoutes);
